// src/pages/ActivationErrorPage.jsx
import React from 'react';

const ActivationErrorPage = () => {
  return (
    <div
      className="activation-message"
      style={{ paddingTop: '60px', textAlign: 'center' }}
    >
      <h2>❌ Enlace inválido o expirado</h2>
      <p>
        El enlace de activación no es válido o ya fue utilizado.<br />
        Si ya activaste tu cuenta, puedes iniciar sesión normalmente.
      </p>
      <a href="/" className="btn">Volver a inicio</a>
    </div>
  );
};

export default ActivationErrorPage;
